// extracted by mini-css-extract-plugin
export var callCard = "_r2-0";
export var callMessageButton = "_r2-1";
export var helpIcon = "_r2-3";
export var helpIconContainer = "_r2-4";
export var verticalDivider = "_r2-2";